import React from 'react';
import startCase from 'lodash/startCase';
import Lozenge, { ThemeAppearance } from '@atlaskit/lozenge';
import { Size } from '@atlaskit/icon';
import { QuoteV2 } from '@atlassian/cssxp-types-quote';
import { NoData } from '@css-xp/ppc-common';
import { QuoteWarningIcon } from './quote-warning-icon';

export const QuoteStatus = ({
  status,
  size,
  hideWarningIcon,
}: {
  status: QuoteV2.QuoteStatus | undefined | null;
  size?: Size;
  hideWarningIcon?: boolean;
}) => {
  if (!status) return <NoData />;

  let appearance: ThemeAppearance;

  switch (status) {
    case QuoteV2.QuoteStatus.CREATION_IN_PROGRESS:
    case QuoteV2.QuoteStatus.ACCEPTED:
      appearance = 'success';
      break;
    case QuoteV2.QuoteStatus.DRAFT:
    case QuoteV2.QuoteStatus.CANCELLED:
      appearance = 'removed';
      break;
    case QuoteV2.QuoteStatus.STALE:
      appearance = 'moved';
      status = QuoteV2.QuoteStatus.NEEDS_REVIEW;
      break;
    case QuoteV2.QuoteStatus.UPDATE_IN_PROGRESS:
    case QuoteV2.QuoteStatus.CANCELLATION_IN_PROGRESS:
    case QuoteV2.QuoteStatus.REVISION_IN_PROGRESS:
    case QuoteV2.QuoteStatus.OPEN:
      appearance = 'inprogress';
      break;
    case QuoteV2.QuoteStatus.FINALIZATION_IN_PROGRESS:
      appearance = 'new';
      break;
    case QuoteV2.QuoteStatus.NEW:
      appearance = 'moved';
      break;
    case QuoteV2.QuoteStatus.ACCEPTANCE_IN_PROGRESS:
    default:
      appearance = 'default';
      break;
  }

  return (
    <>
      {!hideWarningIcon && status === QuoteV2.QuoteStatus.NEEDS_REVIEW && <QuoteWarningIcon size={size} />}
      <Lozenge appearance={appearance} testId={`quote-status--${status.toLowerCase()}`}>
        {startCase(status)}
      </Lozenge>
    </>
  );
};
